import React from 'react';
import PropTypes from 'prop-types';
import Ad from '@ifeng/ui_pc_ad';
import { getCommentCount } from '../../../../services/api';
import errorBoundary from '@ifeng/errorBoundary';

class ShortCommentBottomAd extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        isHasComment: false,
    };

    async componentDidMount() {
        const { skey, commentUrl } = this.props.content;
        const result = await getCommentCount(skey, commentUrl);

        if (result && result.length > 0) {
            this.setState({
                isHasComment: true,
            });
        }
    }

    render() {
        const { isHasComment } = this.state;
        const { ad } = this.props.content;

        return isHasComment ? <Ad content={ad} /> : null;
    }
}

export default errorBoundary(ShortCommentBottomAd);
